import { IStaticPageItem } from '@ui';
import { cloneDeep } from 'lodash';

export const dataMobile: IStaticPageItem[] = [
  {
    title: 'Hotseat - Setup',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              The setup for Hotseat is similar to Taboo, there are just a few key differences.
              `,
              `
              Firstly, as Hotseat is a whole class activity, the number of teams is always set to 2.
              `,
              `
              Similar to Taboo, you’ll want to make sure that the number of words is at least equal to the number of students per team.
              `,
              `
              Enter the keywords for students that the students will have to guess.
              `,
              `
              You’ll notice here that there is no banned word list section, as hotseat doesn’t include any banned words.
              `,
              `
              You can add as many words as you want by clicking ‘add more’.
              `,
              `
              Once you’ve added the game click ‘launch game’ This will give you the option to name the game and save it to a folder, before launching.
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '',
        image: 'learn_more_taboo.png'
      },
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 8,
            value: [
              `
              This will take you to the waiting room, where students can join via a link and a join code, or by scanning a QR code. 
              `,
              `
              Once a student joins the game, they will randomly be assigned to a team. They do have an ability to switch teams. The teacher can also switch teams of any individual student. Note: if all teams are full, students joining will go to an ‘observations’ team, which is for students unassigned to a team.
              `,
              `
              Once all students have joined a team, click on ‘Start game!’
              `
            ]
          }
        ],
        image: '',
        subTitle: ''
      },
      {
        title: '',
        subTitle: '',
        description: [],
        background: '',
        image: 'learn_more_taboo_2.png'
      }
    ],
    subTitle: '',
    titleStyle: ''
  },
  {
    title: 'Hotseat - During Play',
    description: '',
    background: '',
    blocks: [
      {
        title: '',
        background: '',
        description: [
          {
            type: 'list',
            order: true,
            start: 1,
            value: [
              `
              Once you’ve started the game, students will be alerted on their phones (or other personal device) and they will be asked to press ‘ready’.
              `,
              `
              Once they’ve all clicked on ‘ready’ a student will be randomly selected to be a guesser, while the other members of the team are describers.
              `,
              `
              The describers will describe the word to the students in the hotseat. The students in the hotseat will have to shout out the answer quicker than their opponent.
              `,
              `
              Points are awarded by the teacher. The teacher can decide which student was quicker and gets a point. If a student cheated then you can also deduct points.
              `,
              `
              Once a student’s turn has ended, two more students will be selected randomly to be the guesser. 
              `,
              `
              This will be repeated until all words have been described and every student has had a chance to be in the hotseat.
              `,
              `
              Alternatively, the teacher can end the game early, before all words have been described by clicking ‘emergency end game’.
              `,
              `
              Once the game has ended, there will be a game review screen which shows all the words played in that game.
              `,
              `
              The next screen is the score discussion. Scores will be calculated automatically during the game as points are gained / lost. However, if there are any disputes (e.g. a student has wrongfully been deducted points by mistake), the teacher has a chance here to adjust the scores. 
              `,
              `
              Once all scores are finalised, there will be a review of all the words followed by leaderboard displaying the scores of all teams who participated.
              `
            ]
          },
          {
            type: 'string',
            value: [
              'Note that if any students accidentally drop out at any point during the game, they are able to rejoin it by going to the same link, entering the same game code and entering the same name they used to enter previously. They’ll then need to click on ‘rejoin’. This will put them in the same group as they were previously.'
            ]
          }
        ],
        image: '',
        subTitle: ''
      }
    ],
    subTitle: '',
    titleStyle: ''
  }
];

const genDataDesktop = () => {
  const [setup, play] = cloneDeep(dataMobile);

  const setupBlocks = setup.blocks;

  setupBlocks[0].description[0].value =
    setupBlocks[0].description[0].value.concat(
      setupBlocks[2].description[0].value
    );

  setupBlocks[0].image = 'learn_more_hotseat.jpg';
  setupBlocks[0].imageStyle = { marginTop: '-80px' };
  setupBlocks[0].row = true;

  setup.blocks = setup.blocks.slice(0, 1);

  return [
    setup,
    play,
    {
      title: 'Example round',
      description: '',
      background: '#83C0EC',
      blocks: [
        {
          title: '',
          background: '',
          description: [],
          image: 'hotseat_guide.jpg',
          subTitle: '',
          imageFullWidth: true
        }
      ],
      subTitle: '',
      titleStyle: ''
    }
  ];
};

export const dataDesktop: IStaticPageItem[] = genDataDesktop();
